import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './styles/tailwind.css';
import { ToastContainer } from 'react-toastify';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { AuthProvider } from './components/providers/AuthProvider';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import './styles/font.css';
import './styles/common.scss';
import './styles/manning-po.scss';
import './styles/index.css';
import store from './app/store';

ReactDOM.render(
  <AuthProvider>
    <Provider store={store}>
      <ToastContainer enableMultiContainer />
      <App />
    </Provider>
  </AuthProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
